import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
const flow = ['LLAMADA ENTRANTE', 'VOICE', 'IDENTIFICA', 'ENTIENDE', 'CALIFICA', 'AGENDA', 'CRM'];
export function Voice() {
  return <section id="voice" className="bg-arena py-[72px] md:py-[120px]" data-id="element-223" data-mp="68z830rvmx6t">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-224" data-mp="k9jqvwxskt0b">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-carbon rounded-[12px] p-8 md:p-14 text-center" data-id="element-225" data-mp="k7yyodyy9m5m">
          <span className="inline-flex items-center gap-1.5 font-body text-[11px] uppercase tracking-[0.15em] text-salvia mb-5" data-id="element-226" data-mp="yyy0n65a5cg8">
            <Phone size={12} data-id="element-227" data-mp="1vo1hy6sgrg08" /> ORIGEN VOICE
          </span>
          <h2 className="font-display text-[28px] md:text-[40px] font-bold text-arena leading-[1.15] max-w-[560px] mx-auto mb-4" data-id="element-228" data-mp="20m32yx9g9pec">
            Tu empresa también puede contestar el teléfono.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-arena/60 leading-[1.6] max-w-[480px] mx-auto mb-10" data-id="element-229" data-mp="29mj3bxuwcgez">
            Un agente de voz con IA que atiende, entiende, califica, agenda
            y deriva cuando hace falta.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-1.5 mb-10" data-id="element-230" data-mp="2jjdzia3p64q3">
            {flow.map((step, idx) => <Fragment key={step} data-id="element-231" data-mp="2oe1f1jgq3osj" data-mpi={idx}>
                <span className="font-body text-[12px] text-arena/75 bg-arena/10 rounded-full px-3.5 py-1.5" data-id="element-232" data-mp="2sdsgch3vlnbb">
                  {step}
                </span>
                {idx < flow.length - 1 && <span className="text-arena/30 text-[12px]" data-id="element-233" data-mp="32anbqr4ur7ld">→</span>}
              </Fragment>)}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-5" data-id="element-234" data-mp="129gocz87ilcj">
            <a href={getWhatsAppLink('Hola, equipo de Origen Studio. Quiero agregar el módulo VOICE a mi sistema.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-arena text-carbon font-display font-semibold text-[15px] px-7 py-3.5 rounded-[6px] hover:bg-[#EAE7E0] transition-colors duration-200" data-id="element-235" data-mp="xbp0qhelhle5">
              Agregar VOICE <ArrowRight size={16} className="ml-2" data-id="element-236" data-mp="1uy4gnerdiazl" />
            </a>
            <div className="text-left" data-id="element-237" data-mp="1pyrtsu0i53x0">
              <p className="font-body text-[14px] font-medium text-arena/80" data-id="element-238" data-mp="1pzt7z7cte6iy">
                Desde $900.000/mes
              </p>
              <p className="font-body text-[12px] text-arena/40" data-id="element-239" data-mp="k3hstvtpnzi">
                Disponible como módulo adicional.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}